module.exports = __webpack_public_path__ + "img/man.5d06dbbb.webp";